import { RootState } from "@/vuex/types";
import { Module } from "vuex";
import { actions } from "./customer.actions";
import { getters } from "./customer.getters";
import { mutations } from "./customer.mutations";
import { state } from "./customer.state";
import { CustomerState } from "./customer.types";

const namespaced: boolean = true;
export const CustomerModule: Module<CustomerState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
